import { useCallback } from "react"
import { ButtonProps } from "@mezo-org/mezo-clay"

import { usePosthogButtonClickedEvent } from "#/shared/hooks"
import { PosthogAnalyticsId } from "#/shared/types"

import { BridgeAssetButton } from "../Button"

type OverviewBridgeDepositButtonProps = ButtonProps & {
  depositId: number
}

export default function OverviewBridgeDepositButton({
  depositId,
  ...props
}: OverviewBridgeDepositButtonProps) {
  const { emitButtonClickedEvent } = usePosthogButtonClickedEvent()

  const bridgeButtonHandler = useCallback(() => {
    emitButtonClickedEvent(PosthogAnalyticsId.ASSETS_BRIDGE)
  }, [emitButtonClickedEvent])

  return (
    <BridgeAssetButton
      shape="pill"
      kind="secondary"
      size="small"
      onClick={bridgeButtonHandler}
      depositId={depositId}
      {...props}
    >
      Bridge
    </BridgeAssetButton>
  )
}
